import { render, staticRenderFns } from "./toaster-2-polaris-3-packing-page.vue?vue&type=template&id=5795a210"
import script from "./toaster-2-polaris-3-packing-page.vue?vue&type=script&lang=js"
export * from "./toaster-2-polaris-3-packing-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports